export class AssetConsumptionModel {
  static ALLOWED_KEYS = [
    "id",
    "assetId",
    "assetName",
    "assetType",
    "consumedAgainstAssetId",
    "consumedAgainstAssetName",
    "quantity",
    "uom",
    "consumptionDate",
    "remarks",
    "companyId",
    "locationCode",
    "createdBy",
    "createdByEmail",
    "createdDate",
  ];

  constructor(data = {}, { isCreation = false } = {}) {
    for (const key of AssetConsumptionModel.ALLOWED_KEYS) {
      this[key] = null;
    }

    const src = data || {};

    this.id = src.id || (isCreation ? this._generateId() : null);
    this.assetId = src.assetId || "";
    this.assetName = src.assetName || "";
    this.assetType = src.assetType || "Consumable";
    this.consumedAgainstAssetId = src.consumedAgainstAssetId || "";
    this.consumedAgainstAssetName = src.consumedAgainstAssetName || "";

    const parsedQty = Number(src.quantity);
    this.quantity = Number.isFinite(parsedQty) ? parsedQty : 0;

    this.uom = src.uom || "Nos";
    this.consumptionDate =
      this._toIso(src.consumptionDate) || new Date().toISOString();
    this.remarks = src.remarks || "";
    this.companyId = src.companyId || "";
    this.locationCode = src.locationCode || "";
    this.createdBy = src.createdBy || "";
    this.createdByEmail = src.createdByEmail || "";
    this.createdDate =
      this._toIso(src.createdDate) || new Date().toISOString();
  }

  _toIso(val) {
    if (!val) return null;
    if (typeof val?.toDate === "function") return val.toDate().toISOString();
    if (val instanceof Date) return val.toISOString();
    if (typeof val === "object" && "seconds" in val) {
      return new Date(val.seconds * 1000).toISOString();
    }
    const d = new Date(val);
    return isNaN(d.getTime()) ? null : d.toISOString();
  }

  _generateId() {
    return typeof crypto !== "undefined" &&
      typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `CONS-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  }

  isValid() {
    if (!this.id) return false;
    if (!this.assetId) return false;
    if (!this.consumedAgainstAssetId) return false;
    if (
      !Number.isFinite(Number(this.quantity)) ||
      Number(this.quantity) <= 0
    )
      return false;
    if (!this.companyId) return false;
    return true;
  }

  getValidationErrors() {
    const errors = [];
    if (!this.assetId) errors.push("Asset ID is required.");
    if (!this.consumedAgainstAssetId)
      errors.push("Target asset (consumed against) is required.");
    if (!Number.isFinite(Number(this.quantity))) {
      errors.push("Quantity must be a valid number.");
    } else if (Number(this.quantity) <= 0) {
      errors.push("Quantity must be greater than zero.");
    }
    if (!this.companyId) errors.push("Company ID is required.");
    return errors;
  }

  toPayload() {
    const payload = {};
    for (const key of AssetConsumptionModel.ALLOWED_KEYS) {
      const v = this[key];
      if (v !== undefined && v !== null) payload[key] = v;
    }
    return payload;
  }
}